const gaTags = {
  class: "ga-eventos",
  categoryDefault: "AutoCompra-Consórcio",
  categoryFlow: "AutoCompra-Consórcio-Fluxo",
  type: "AC-Consórcio-",
  typeFlow: "AC-Consórcio-Fluxo1-",
  typeFlow2: "AC-Consórcio-Fluxo",
};


export default gaTags;
